/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Request body parameter that contains delivery info details such as the flex delivery flag, flex delivery comment 1/2 and pakkeboks id.
 * 
 * The DTO is in XML or .json format.
 * @export
 * @interface DeliveryInfo
 */
export interface DeliveryInfo {
    /**
     * 
     * @type {string}
     * @memberof DeliveryInfo
     */
    flexDeliveryComment1?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryInfo
     */
    flexDeliveryComment2?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryInfo
     */
    pakkeboksId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryInfo
     */
    actingUserId?: string;
}

/**
 * Check if a given object implements the DeliveryInfo interface.
 */
export function instanceOfDeliveryInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeliveryInfoFromJSON(json: any): DeliveryInfo {
    return DeliveryInfoFromJSONTyped(json, false);
}

export function DeliveryInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'flexDeliveryComment1': !exists(json, 'flexDeliveryComment1') ? undefined : json['flexDeliveryComment1'],
        'flexDeliveryComment2': !exists(json, 'flexDeliveryComment2') ? undefined : json['flexDeliveryComment2'],
        'pakkeboksId': !exists(json, 'pakkeboksId') ? undefined : json['pakkeboksId'],
        'actingUserId': !exists(json, 'actingUserId') ? undefined : json['actingUserId'],
    };
}

export function DeliveryInfoToJSON(value?: DeliveryInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'flexDeliveryComment1': value.flexDeliveryComment1,
        'flexDeliveryComment2': value.flexDeliveryComment2,
        'pakkeboksId': value.pakkeboksId,
        'actingUserId': value.actingUserId,
    };
}

